<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12 pt-0 pb-2">
        <h1>
          Survey for quotation: #{{ quotation.jobNumber }}
          <router-link
            class="float-right"
            :to="`/quotations/link-survey/${quotation.id}`">
            <v-btn
                small
                class="relative"
                style="top:-4px">
              Change Survey
            </v-btn>
          </router-link>
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-8">
        <h2 class="large-heading pb-4">Works Survey</h2>
        <h4>Date: {{ survey.prettyDate }}</h4>
        <p class="pt-2">Customer reference: {{ survey.customer_reference }}</p>
        <p>
          Work areas:
          <span v-if="survey.internal">Internal</span>
          <span v-if="survey.external">External</span>
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-4">
      <v-col class="col-4">
        &nbsp;
      </v-col>
      <v-col class="col-4">
        <label>
          Select all Photos
          <input
              type="checkbox"
              style="display:inline;"
              v-model="selectAllPhotos" />
        </label><br />
        <label>
          Show all to Crews
          <input
              type="checkbox"
              style="display:inline;"
              v-model="showAllToCrews" />
        </label>
      </v-col>
    </v-row>
    <hr />
    <v-row class="pt-4" :key="index" v-for="(section, index) in surveySections">
      <v-col class="col-4">
        <p>Item #{{ (index + 1) }}</p>
        <p>{{ section.title}}</p>
        <p>{{ section.description }}</p>
        <p>BOQs:</p>
        <p v-for="(boq, boqindex) in section.boqs" :key="boqindex">
          {{ boq.quantity }} {{ boq.unit }} {{ boq.boq }} in {{ boq.colour }} {{ boq.material }}
        </p>
      </v-col>
      <v-col class="col-8">
        <v-row>
          <v-col
              class="col-3"
              :key="findex"
              v-for="(file, findex) in section.files">
            <img :src="file.uri" alt="" />
            <label>
              Select photo
              <input
                  type="checkbox"
                  style="display:inline;"
                  v-model="file.importPhoto" />
            </label><br />
            <label>
              Show to crews
              <input
                  type="checkbox"
                  style="display:inline;"
                  v-model="file.show_to_crews" />
            </label>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="col-12">
        <hr class="mt-4" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p>
          Click below to import the BOQs and/or photos from the survey into the quotation.<br /><br />
          <strong>Please note:</strong>
        </p>
        <ul>
          <li>Any existing sections and quotation lines will be removed from the quotation</li>
          <li>Any existing quotation documents will be removed</li>
          <li>A new section will be created for each survey section</li>
        </ul>
        <br />
        <label>
          Import BOQs
          <input type="checkbox" v-model="importBoqs" />
        </label>
        <br />
        <label>
          Import Photos
          <input type="checkbox" v-model="importPhotos" />
        </label>
        <br />
        <v-btn class="mt-4" @click="importSurvey">Import</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'QuotationsViewSurvey',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  data() {
    return {
      customerName: '',
      importBoqs: true,
      importPhotos: true,
      quotation: {
        contact_id: 0,
        postCode:'',
        purchase_order: '',
        purchase_order_uri: '',
      },
      selectAllPhotos: false,
      showAllToCrews: false,
      survey: {},
      surveySections: [],
      message: '',
      showMessage: false,
    };
  },
  watch: {
    surveySections: {
      handler() {
        this.updateShowToCrews();
      },
      deep: true
    },
    selectAllPhotos() {
        for (let i = 0; i < this.surveySections.length; i++) {
          for (let j = 0; j < this.surveySections[i].files.length; j += 1) {
            this.surveySections[i].files[j].importPhoto = this.selectAllPhotos;
        }
      }
    },
    showAllToCrews() {
      for (let i = 0; i < this.surveySections.length; i++) {
        for (let j = 0; j < this.surveySections[i].files.length; j += 1) {
          this.surveySections[i].files[j].show_to_crews = this.showAllToCrews;
        }
      }
    },
  },
  methods: {
    getQuotation() {
      axios.get(`/quotations/getSingle/${this.$route.params.id}.json?token=${this.token}`)
      .then((response) => {
        this.quotation = response.data;
        this.getSurvey();
      });
    },
    getSurvey() {
      axios.get(`/siteSurveys/getOne/${this.quotation.site_survey_id}.json?token=${this.token}`)
      .then((response) => {
        this.survey = response.data.survey;
        this.getSurveySections();
      });
    },
    getSurveySections() {
      axios.get(`/siteSurveySections/get/${this.survey.id}.json?token=${this.token}`)
        .then((response) => {
          this.surveySections = response.data.sections;
        });
    },
    importSurvey() {
      const postData = {
        importBoqs: this.importBoqs,
        importPhotos: this.importPhotos,
        sections: this.surveySections,
      };
      axios.post(`/quotations/importSurvey/${this.quotation.id}/${this.survey.id}.json?token=${this.token}`, postData)
          .then(() => {
            this.$router.push(`/quotations/view/${this.quotation.id}`);
          });
    },
    updateShowToCrews() {
      axios.post(`/filesSiteSurveySections/updateShowToCrews.json?token=${this.token}`, this.surveySections);
    }
  },
  mounted() {
    this.getQuotation();
  },
};
</script>
